import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import MuiTooltip from '@mui/material/Tooltip';
import Icon from '@cpg-its/ads.common.icon';
import { black, grey, white } from '@cpg-its/ads.constants.colors';
const IconWrapper = styled(MuiGrid)({
    display: 'inline-flex',
    position: 'relative',
    top: 3,
});
const LabelWrapper = styled(MuiGrid)({
    display: 'inline-flex',
});
const CustomIconOrLabel = React.forwardRef((props, ref) => {
    const { color, icon, label } = props;
    if (label) {
        return (_jsx(LabelWrapper, { ...props, ref: ref, children: label }));
    }
    return (_jsx(IconWrapper, { ...props, ref: ref, children: _jsx(Icon, { icon: icon, size: "small", color: color }) }));
});
CustomIconOrLabel.displayName = 'TooltipIcon';
export const TooltipComponent = ({ backgroundColor = '', icon = 'tooltip', iconColor = '', disableInteractive = false, label = '', leaveDelay = 0, placement = 'right', testId = undefined, textColor = '', title = '', }) => (_jsx(MuiTooltip, { "data-testid": testId, disableInteractive: disableInteractive, leaveDelay: leaveDelay, placement: placement, title: title, arrow: true, componentsProps: {
        tooltip: {
            sx: {
                '& .MuiTooltip-arrow': {
                    '&:before': {
                        border: `1px solid ${backgroundColor || grey}`,
                    },
                    color: backgroundColor || white,
                    fontSize: '.75rem',
                },
                backgroundColor: backgroundColor || white,
                border: `1px solid ${backgroundColor || grey}`,
                boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
                color: textColor || (backgroundColor ? white : black),
                padding: '1rem',
            },
        },
    }, children: _jsx(CustomIconOrLabel, { color: iconColor, icon: icon, label: label }) }));
export default TooltipComponent;
//# sourceMappingURL=tooltip.js.map